import React from "react";
import { Search } from "lucide-react";

import { cn } from "src/utils/cn";
import { useSidebar } from "src/contexts/SidebarContext";
import { useSearch } from "src/contexts/SearchContext";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "src/components/ui/tooltip";

export function SidebarSearchTrigger() {
  const { collapsed } = useSidebar();
  const { openSearch } = useSearch();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={openSearch}
          className={cn(
            "flex h-10 w-full items-center rounded-xl border border-slate-200 px-3 text-sm text-[#24243a] transition-colors",
            collapsed
              ? "justify-center bg-transparent hover:bg-white/70"
              : "justify-between bg-white hover:border-slate-300"
          )}
        >
          <span className="flex items-center gap-2.5">
            <Search className="h-4 w-4 shrink-0 text-slate-600" />
            {!collapsed ? <span className="font-medium">Search</span> : null}
          </span>

          {!collapsed ? (
            <span className="flex items-center gap-1 text-[10px] font-semibold text-slate-500">
              <span className="rounded-md bg-slate-100 px-1.5 py-1 leading-none">⌘</span>
              <span className="rounded-md bg-slate-100 px-1.5 py-1 leading-none">K</span>
            </span>
          ) : null}
        </button>
      </TooltipTrigger>
      {collapsed ? (
        <TooltipContent side="right">Search (⌘K)</TooltipContent>
      ) : null}
    </Tooltip>
  );
}

